import { render, staticRenderFns } from "./cadastroPregao.vue?vue&type=template&id=748a4dbc"
import script from "./cadastroPregao.vue?vue&type=script&lang=js"
export * from "./cadastroPregao.vue?vue&type=script&lang=js"
import style0 from "./cadastroPregao.vue?vue&type=style&index=0&id=748a4dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports